module.exports = __webpack_public_path__ + "img/frost.fe341ae2.jpg";